import React, { Component } from "react";
import Slider from "react-slick";
import { TeachData } from "../../db/TeachData";
import { Col, Container, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./PopularTeach.css";
import { BsStarFill } from "react-icons/bs";

export default class SimpleSlider extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: true,
      //   autoplay: true,
      speed: 2000,
      slidesToShow: 4,
      slidesToScroll: 4,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
    };
    return (
      <Container className="py-5">
        <div className="dev-title">
          <h2>Popular Instructors</h2>
        </div>
        <Container>
          <Slider {...settings}>
            {TeachData.map((item, index) => {
              return (
                <Col key={item.id}>
                  <div className="teach-s">
                    <Link to={item.path}>
                      <Image
                        className="teach-img"
                        variant="top"
                        fluid
                        src={item.img}
                      />
                      <div className="teach-p">
                        <div className="name">{item.name}</div>
                        <div className="special">{item.speciality}</div>
                        <div className="star">
                          {item.star}{" "}
                          <span>
                            <BsStarFill />
                          </span>
                          <> Instructor Rating</>
                        </div>
                        <div className="students">{item.students} students</div>
                        <div className="courses">{item.courses} courses</div>
                      </div>
                    </Link>
                  </div>
                </Col>
              );
            })}
          </Slider>
        </Container>
      </Container>
    );
  }
}
